export const ACTIONS_MANUFACTURER = {
  INVALIDATE: 'MANUFACTURERS_INVALIDATE',
  RECEIVE: 'MANUFACTURERS_RECEIVE',
  DELETE: 'MANUFACTURER_DELETE',
  UPDATE: 'MANUFACTURER_UPDATE',
};

const manufacturerConstants = {};

export default manufacturerConstants;
